const React = require('react');
const ReactDom = require('react-dom');
const Input = require('../input/index');
const css = require('./module.scss');


/**
 * 使用方法：
 * <Select options={[
 *     {name: 'apple', value: 1}
 * ]} size="lg" wtype='1' disabled={true}/>
 *
 * size: 高度控制，不设置时默认为default高度，可设置为sm, lg
 * wtype: 宽度控制，不设置时自适应，可设置为1，2
 * disabled 属性为不可操作
 * filterable : 是否输入过滤选项
 * keyMap: { // 选项的key, 默认是 name, value, children
 *      name: '',
 *      value:'',
 *      children: ''
 * }
 * val: 选择的值
 * showTree: 显示树形结构的数据
 * clearable: 可清除已经选择的值
 * position：'', style的定位属性，用于调整下拉面板显示的问题
 * height:'100px',定义下拉框的高度
 *
 * 事件：
 *  onChange: (value)
 */

const defaultKeyMap = {
    name: 'name',
    value: 'value'
};

const _body = document.body;

let ie = /msie (\d+\.\d+)/i.test(navigator.userAgent) ? (document.documentMode || + RegExp['\x241']) : undefined;

const Select = React.createClass({
    getInitialState() {
        const { value, filterable, options, placeholder, disabled, showTree } = this.props;
        let totalDataValueMap = this.generateValueMap(options, defaultKeyMap);
        return {
            show: false,
            showName: this.findOptionsName(value, totalDataValueMap),
            keyMap: defaultKeyMap,
            showTree: showTree || false,
            value: value || "",
            filterable: !disabled ? filterable || false : false,
            showOptions: options || [],
            totalOptions: options || [],
            placeholder: placeholder || '请选择',
            showMap: {},
            inputHovering: false,
            pRect: {},
            top: 0,
            position: this.props.position || "absolute",
            totalDataValueMap
        };
    },

    onClick(event) {
        if (this.props.disabled) return;

        if (ie <= 9) {
            if (this.state.showName === '请选择') {
                this.state.showName = '';
            }
            this.setState();
        }

        let parent = ReactDom.findDOMNode(this.refs['selectInput']);
        let dropDown = ReactDom.findDOMNode(this.refs['dropdown']);

        let pRect = parent.getBoundingClientRect();

        let pHeight = pRect.bottom - pRect.top;

        this.setState({
            show: !this.state.show,
            pRect
        }, () => {

            if (this.state.show) {
                let dRect = dropDown.getBoundingClientRect();

                let pBottom = _body.clientHeight - pRect.bottom; // 输入框到页面底部的距离
                let dropDownHeight = dRect.bottom - dRect.top;

                let top = 0;
                // 下拉面板需要放在输入框上面
                if (pBottom < dropDownHeight && pRect.top >= dropDownHeight) {
                    top = - (dropDownHeight + 12);
                } else {
                    top = pHeight;
                }
                this.setState({ top });
                // console.log(dRect);
            }
        });
    },

    generateValueMap(options, keyMap) {
        const { value, name } = keyMap;
        let valueMap = {};

        const traverseTree = (node) => {
            if (node) {
                valueMap[node[value]] = node[name];
            }
        };

        if (options && options.length > 0) {
            options.forEach(node => traverseTree(node));
        }
        return valueMap;

    },
    findOptionsName(val, totalDataValueMap) {
        return totalDataValueMap ? totalDataValueMap[val] : "";
    },
    componentWillReceiveProps(nextProps) {
        let {keyMap} = this.state;
        let totalDataValueMap = this.generateValueMap(nextProps.options, keyMap);
        let showName = this.findOptionsName(nextProps.value, totalDataValueMap);
        if (ie <= 9) {
            if (showName === undefined || showName === '') {
                showName = '请选择';
            }
        }
        if (nextProps.name==='addusername'&&nextProps.value!=='请选择'){//修复地块采集测量员数据回显bug
            showName = nextProps.value;
        }
        this.setState({
            value: nextProps.value,
            showName: showName,
            showOptions: nextProps.options || [],
            totalOptions: nextProps.options || [],
            totalDataValueMap
        });

    },

    contains(evt, domRef) {
        let parent = ReactDom.findDOMNode(this.refs[domRef]);
        if (parent) {
            let rect = parent.getBoundingClientRect();
            return (evt.clientX >= rect.left && evt.clientX <= rect.right)
                && (evt.clientY >= rect.top && evt.clientY <= rect.bottom);
        } else {
            return false;
        }

    },

    filterOption(e) {
        this.props.onSearch && this.props.onSearch({ //输入值回调方法
            target: {
                name: this.props.name,
                value: e.target.value
            }  // 这里为了兼容之前的select设置值的入参格式，没有办法了~
        });
        const { totalOptions, keyMap } = this.state;
        let keyword = e.target.value;
        let showOptions = keyword ? totalOptions.filter(item => item[keyMap.name].match(keyword.replace(/\\/g, '\\\\'))) : totalOptions;
        this.setState({ showName: keyword, showOptions: showOptions});
    },

    componentWillMount() {
        // this.unmount = false;
        // if (document.removeEventListener) {
        //     document.removeEventListener('click', this.handleClickOutSide);
        // } else {
        //     document.detachEvent('onclick', this.handleClickOutSide);
        // }
    },

    handleClickItem(item, event) {
        const { showMap, keyMap } = this.state;

        let value = item[keyMap.value];
        let showName = item[keyMap.name];
        this.setState({
            showName: showName,
            value: value,
            show: false
        });
        if (value != this.state.value) {
            this.props.onChange && this.props.onChange({
                target: {
                    name: this.props.name,
                    value: value
                }  // 这里为了兼容之前的select设置值的入参格式，没有办法了~
            });
        }
        ReactDom.findDOMNode(this.refs.inputItem).focus();
    },

    handleClickOutSide(event) {
        if (this.unmount) {
            return;
        }
        const { show } = this.state;
        if (!show) return;
        if (this.contains(event, 'selectInput')) return;
        if (this.contains(event, 'dropdown')) return;

        this.setState({ show: false });
    },

    componentDidMount() {
        this.unmount = false;
        if (document.addEventListener) {
            document.addEventListener('click', this.handleClickOutSide);
        } else {
            document.attachEvent('onclick', this.handleClickOutSide);
        }
    },

    componentWillUnmount() {
        this.unmount = true;
        if (document.removeEventListener) {
            document.removeEventListener('click', this.handleClickOutSide);
        } else {
            document.detachEvent('onclick', this.handleClickOutSide);
        }
    },

    renderOption(item, index) {
        const {name, value} = this.state.keyMap;
        return <li className={'fp-select-dropdown-item'} key={index}>
            <div className={"option-node" + (this.state.value == item[value] ? ' selected' : '')}
                onClick={this.handleClickItem.bind(this, item)}>
                <span>{item[name]}</span>
            </div>
        </li>;
    },

    render() {
        let { showName, showOptions, filterable, placeholder, show, pRect, top, position } = this.state;
        const { className, size, wtype, disabled, name,height,type } = this.props;
        let cls = ['fp-form-select', className];
        if (disabled) {
            cls.push('is-disabled');
        }
        if (type == 'hidden') {
            return null;
        }

        return <div className={cls.join(' ')} ref="selectInput">
            <Input ref="inputItem"
                value={showName}
                readonly={!filterable}
                size={size}
                wtype={wtype}
                name={name}
                disabled={disabled}
                onClick={this.onClick}
                onChange={this.filterOption}
                placeholder={placeholder}
            />
            <i className={"fp-select-icon " + (show ? 'fp-up' : 'fp-down')} onClick={this.onClick}></i>
            <ul className="fp-select-dropdown" ref="dropdown" style={{
                width: pRect.right ? (pRect.right - pRect.left) : 0,
                'min-width': 120,
                height:height? height : 'auto',
                position: position,
                top: position === 'absolute' ? top : null,
                display: show ? 'block' : 'none'
            }}>
                {showOptions.map((item, index) => this.renderOption(item, index))}
            </ul>
        </div>;
    }
});

module.exports = Select;



// WEBPACK FOOTER //
// ./component/select/index.js